module.exports = __webpack_public_path__ + "static/img/1040_big.5f30be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1040_big.png
// module id = XIGC
// module chunks = 1